import { render } from "./ModalContentWorkbook.vue?vue&type=template&id=4821c035&scoped=true&lang=true"
import script from "./ModalContentWorkbook.vue?vue&type=script&lang=js"
export * from "./ModalContentWorkbook.vue?vue&type=script&lang=js"

import "./ModalContentWorkbook.vue?vue&type=style&index=0&id=4821c035&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4821c035"

export default script